/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './ErrorScreen.style';

import messages from 'src/shared/app/base/l10n/errorL10n';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { supportRoute } from 'src/shared/app/base/route/setting/routeSettings';
import LazySupportMain from 'src/shared/app/support/component/LazySupportMain';
import { Link } from 'react-router-dom';
import ErrorScreen from './ErrorScreen';

type Props = {
  sentryId: ?string,
  error: Error,
  errorInfo: Object,
  isErrorReportingEnabled: boolean,
};

const useStyles = createUseThemeStyles(styles);

const Error500Dumb = ({
  sentryId,
  error,
  errorInfo,
  isErrorReportingEnabled,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [supportPath] = useRoutes(supportRoute);

  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onRetry = () => window.location.reload();

  const onMouseOver = () => LazySupportMain.preload();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const detailsElt =
    isErrorReportingEnabled && sentryId ? (
      <p className={classes.ref}>
        <span className={classes.refLabel}>
          {intl.formatMessage(messages.errorId)}
        </span>
        <br />
        <span className={classes.refId}>{sentryId}</span>
      </p>
    ) : (
      <div className={classes.message}>
        <p>{error.message}</p>
        {errorInfo.componentStack.split('\n').map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>
    );
  return (
    <ErrorScreen
      title={intl.formatMessage(messages.genericError)}
      actionLabel={intl.formatMessage(messages.retry)}
      actionOnClick={onRetry}
      extraAction={
        <Link to={supportPath} onMouseOver={onMouseOver}>
          {intl.formatMessage(messages.contact)}
        </Link>
      }
      extraContent={detailsElt}
    />
  );
};

export default React.memo<Props>(Error500Dumb);
